export default {
    "textToast": {
      "sendQueryText": "Zure iritzia benetan eskertzen dugu. Zure esperientzia garrantzitsua da guretzat eta zure itxaropenak betetzeko ahalegina egiten dugu",
      "updateQueryText": "Aldaketa bidalia",
      "registerResponse": "Iritzia bidalia",
      "updateResponse": "Iritzia aldatu da"
    },
    "form": {
      "send": "Bidali",
      "sending": "Bidaltzen",
      "modify": "Aldatu",
      "cancel": "Ezeztatu",
      "title": "Iritzia",
      "hello": "Kaixo",
      "whatsup": "Nola zaude?",
      "thanksAll": "Nola egin dugu?",
      "btn-verywrong-stay": "Oso txarra",
      "btn-wrong-stay": "Txarra",
      "btn-normal-stay": "Normala",
      "btn-good-stay": "Ona",
      "btn-verygood-stay": "Oso ona",
      "btn-verywrong-poststay": "Oso txarra",
      "btn-wrong-poststay": "Txarra",
      "btn-normal-poststay": "Normala",
      "btn-good-poststay": "Ona",
      "btn-verygood-poststay": "Oso ona",
      "poststay-bad-thanks-title": "Erantzuna bidalia",
      "poststay-bad-thanks-subtitle": "Eskerrik asko zure denboragatik",
      "continueIn": "Baloratu hemen",
      "received-text": "Jasota",
      "sent-text": "Bidalia"
    },
    "settings": {
      "questionpre-stay": "Zure iritsierarako zerbait egin dezakegu",
      "questionin-stay": "Nola baloratuko zenuke zure asebetetze maila orain arteko egonaldiarekin?",
      "questionpost-stay": "Nola baloratuko zenuke zure asebetetze maila {lodging} egonaldiarekin?"
    },
    "inbox": {
      "title": "Mezuak"
    },
    "popup": {
      "thanksResponse": "Eskerrik asko zure erantzunagatik",
      "sorryResponse": "Barkatu oso {guestName}!",
      "sorryDescription": "Barkatu ez genuela zure itxaropenak bete. Zure iritziak jaso ditugu eta hobetzeko lan egingo dugu. Eskerrik asko hobetzen laguntzeagatik!",
      "bannerHome-in-stay": {
        "title": "Nola doa dena?",
        "subtitle": "Pozik izango ginateke nola sentitzen zaren jakiteko."
      },
      "bannerHome-post-stay": {
        "title": "Nola izan da zure esperientzia?",
        "subtitle": "Zure iritzia ezagutzea gustatuko litzaiguke zure egonaldiari buruz"
      }
    }
  }
  